import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import { SupportTicketId as SupportTicketIdSchema } from "@redotech/effect-api-shared/ids/definitions";
import { isValidEmail } from "@redotech/util/email";

export interface SupportTicketCollectionFilter {
  readonly field: readonly (string | number)[] | string;
  readonly operator: string;
  readonly value?: unknown;
}

export function getSupportTicketIdScope(
  filters: readonly SupportTicketCollectionFilter[],
): SupportTicketId | null {
  const supportTicketIdFilter = filters.find(
    (f) =>
      (Array.isArray(f.field) ? f.field[0] : f.field) === "supportTicketId",
  );

  if (
    supportTicketIdFilter?.operator !== "eq" ||
    typeof supportTicketIdFilter.value !== "string"
  ) {
    return null;
  }

  return SupportTicketIdSchema.make(supportTicketIdFilter.value);
}

export function requireSupportTicketIdScope(
  filters: readonly SupportTicketCollectionFilter[],
): SupportTicketId {
  const supportTicketId = getSupportTicketIdScope(filters);
  if (!supportTicketId) {
    throw new Error(
      "Collection requires a single supportTicketId equality filter",
    );
  }
  return supportTicketId;
}

export function getEmailScope(
  filters: readonly SupportTicketCollectionFilter[],
  fieldName: string,
  validateEmail: boolean,
): string | null {
  const emailFilter = filters.find(
    (f) => (Array.isArray(f.field) ? f.field[0] : f.field) === fieldName,
  );

  if (emailFilter?.operator !== "eq" || typeof emailFilter.value !== "string") {
    return null;
  }

  if (validateEmail && !isValidEmail(emailFilter.value)) {
    return null;
  }

  return emailFilter.value;
}
